export async function uploadEditorFile(endpoint: string, file: File): Promise<string> {
  const token = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content ?? ""
  const data = new FormData()
  data.append("file", file)

  const response = await fetch(endpoint, {
    method: "POST",
    headers: { "X-CSRF-Token": token },
    body: data,
  })

  if (!response.ok) {
    const problem = await response.json().catch(() => ({}))
    throw new Error(problem.error ?? "That file could not be uploaded.")
  }

  const { url } = await response.json()
  return url
}
